<template>
 <div class="refill-partner">
   <article class="lesta-cards">
     <div class="lesta-cards_content">
       <div class="lesta-cards_inner">
         <div class="lesta-cards__logo-wrap">
           <img
             class="lesta-cards__logo"
             src="../../views/SetCountry/assets/logo.svg"
           >
         </div>
         <div class="lesta-cards__title">
           {{ $t('Выберите ваш банк для пополнения карты.') }}
         </div>
         <div class="lesta-cards__body">
           <ul class="lesta-cards_countries">
             <li class="country" v-for="partner in availablePartnersData" v-bind:key="partner.tag">
               <a
                 :href="partner.depositUrl"
                 class="country__link country__link__just-border"
                 @click="btnClick('ru')"
               >
                 <img :src="`/img/partners/${partner.img}.png`" alt="">
               </a>
             </li>
           </ul>
           <div class="lesta-cards__info">
             {{ $t('* Пополнение осуществляется без комиссии со стороны выбранного банка') }}
           </div>
         </div>
       </div>
     </div>
   </article>
 </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import { State } from 'vuex-class'
import { AVAILABLE_PARTNERS } from '@/constants'

@Component
class RefillPartnerOverlay extends Vue {
  @State('country') currentCountry

  get availablePartnersData () {
    const sect = AVAILABLE_PARTNERS[this.currentCountry]
    return Object.keys(sect).map(item => ({ img: item, ...sect[item][0] }))
  }
}
export default RefillPartnerOverlay
</script>

<style lang="scss">
.refill-partner {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: url("../../views/SetCountry/assets/bg.jpg") center center no-repeat;
  background-size: cover;
  .lesta-cards {
    padding-top: 0;
  }
}
</style>
